<template>
  <!-- Home, signed out (SPEC §4.2): the logo, what slowGo is, and the two ways in. Signed in, /
       opens the game list (router.js). -->
  <div class="home">
    <img class="logo" :alt="t('app-name')" src="../assets/slowgo.png">
    <h1>{{ t('app-name') }}</h1>
    <p class="tagline">{{ t('home-tagline') }}</p>
    <router-link :to="{ name: 'signin' }" class="btn-main">{{ t('home-sign-in-link') }}</router-link>
    <router-link :to="{ name: 'register' }" class="btn-secondary">{{ t('home-register-link') }}</router-link>
    <!-- Without a licence configured (a test site); with one, the footer of every page shows it (App.vue). -->
    <a v-if="!$store.state.site.icpLicense" class="no-icp" href="http://beian.miit.gov.cn/">{{ t('home-no-icp') }}</a>
  </div>
</template>

<script>
import { t } from '@/texts';

export default {
  name: 'LoginView',

  methods: { t },
}
</script>

<style scoped>
.home {
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 260px;
  margin: 0 auto;
  padding-top: 48px;
}

.logo {
  width: 108px;
}

h1 {
  margin: 16px 0 2px;
  font-size: 24px;
}

.tagline {
  margin: 0 0 26px;
  color: #777;
  font-size: 15px;
}

.btn-main, .btn-secondary {
  width: 100%;
  margin-bottom: 12px;
  font-size: 16px;
  text-decoration: none;
}

.no-icp {
  margin-top: 28px;
  color: #aaa;
  font-size: 12px;
}
</style>
